import { ApolloClientState } from "./types"

export const selectApolloClient = (state: {
  apolloClient: ApolloClientState
}) => state.apolloClient.client
